export const CricrushConfig = {
        "ccServiceBaseUrl" : "https://service2.cricrush.com/cc/service/v2",
        "ccChatsBaseUrl" : "http://18.218.238.211:3000",
        "firebaseConfig": {
            "apiKey": "AIzaSyA2-73iYXL-J4BQs8eqB6VXbzbnRjVqRpI",
            "authDomain": "cricrush-171503.firebaseapp.com",
            "databaseURL": "https://cricrush-171503.firebaseio.com",
            "projectId": "cricrush-171503",
            "storageBucket": "cricrush-171503.appspot.com",
            "messagingSenderId": "540610660257",
            "env" : "prod"
        },
        "googleSigninConfig": {
            "iosClientId": "540610660257-74ps9ti8pjdeq08rvmdeg97bqr1uvjmp.apps.googleusercontent.com",
            "webClientId": "540610660257-siqid6fql8p6tudn4jcatcgkn23q0288.apps.googleusercontent.com"
        },
        "cloudMessaging" : {
            "senderId":"540610660257",
            "authKey":"AIzaSyDRDRpjp34hQ9OQlu0noVkPLEpAeWZeiik"
        },
        "dynamicLinkDomain" : "ubsb8.app.goo.gl"
    }
;



// WEBPACK FOOTER //
// ./src/app/config/CricrushConfig.js